import React from "react";
import { uniqueId } from "lodash";
import { IllustrationProps } from ".";

const uid = uniqueId();

export default ({ colors }: IllustrationProps) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 440 120"
    fill={colors.content.tertiary}
  >
    <defs>
      <circle id={"disc" + uid} cx={39.5} cy={18.5} r={18.5} />

      <g id={"line" + uid}>
        <mask id={"mask" + uid} fill="#FFF">
          <use xlinkHref={"#disc" + uid} />
        </mask>
        <use xlinkHref={"#disc" + uid} />
        <path
          d="M51.677 26.355a4.784 4.784 0 01-.896-.65 5.523 5.523 0 01-1.094-1.019 13.982 13.982 0 01-.895-1.204c1.144-1.483 1.766-3.244 1.79-5.075C50.582 13.24 45.534 9 39.292 9 33.048 9 28 13.24 28 18.407S32.95 28 39.192 28c2.387-.023 4.725-.649 6.74-1.854a6.7 6.7 0 002.089.927c.621.185 1.243.348 1.89.464.423.046.87.092 1.293.185h.498L52 26.61l-.323-.255z"
          fill={colors.content.primary}
          mask={`url(#mask${uid})`}
          transform="matrix(-1 0 0 1 80 0)"
        />
      </g>
    </defs>

    <g fill={colors.content.secondary}>
      <path d="M6 26V14H4.672L1 16.454l.835.936c1.34-.941 2.094-1.475 2.258-1.6.164-.127.313-.247.446-.362-.05.635-.076 1.308-.076 2.02V26H6z" />
      <path d="M9 65v-1.35H1.957v-.07l2.997-2.744c1.336-1.215 2.248-2.22 2.735-3.015.487-.795.73-1.599.73-2.411 0-1.04-.365-1.869-1.095-2.485-.73-.617-1.74-.925-3.025-.925-1.486 0-2.86.49-4.121 1.473l.824.99c.624-.461 1.191-.78 1.7-.955a4.925 4.925 0 011.615-.263c.787 0 1.402.2 1.845.6.444.4.665.943.665 1.626 0 .485-.087.938-.262 1.36-.175.42-.437.852-.787 1.296-.35.445-1.074 1.187-2.172 2.227L0 63.746V65h9z" />
      <path d="M3.762 108c1.674 0 2.965-.324 3.874-.973.91-.649 1.364-1.576 1.364-2.78 0-.843-.266-1.523-.8-2.042-.532-.519-1.35-.842-2.454-.969v-.069c.903-.173 1.6-.516 2.093-1.03.492-.512.738-1.173.738-1.98 0-.98-.37-1.751-1.11-2.314C6.727 95.281 5.69 95 4.354 95c-.815 0-1.59.117-2.327.35a6.787 6.787 0 00-1.952.965l.79.968c.684-.403 1.292-.68 1.825-.83a6.26 6.26 0 011.702-.225c.79 0 1.415.176 1.876.528.46.352.691.836.691 1.453 0 .773-.313 1.377-.94 1.812-.627.435-1.477.653-2.549.653H2.097v1.237h1.354c2.621 0 3.931.767 3.931 2.3 0 1.713-1.188 2.57-3.564 2.57-.602 0-1.24-.071-1.914-.212A9.08 9.08 0 010 105.95v1.367c.57.253 1.158.43 1.763.532.605.1 1.271.151 1.999.151z" />
    </g>

    <use xlinkHref={"#line" + uid} />
    <rect x={80} y={10} width={184} height={6} rx={3} />
    <rect x={80} y={21} width={127} height={6} rx={3} />
    <rect x={384} y={16} width={56} height={6} rx={3} />

    <use xlinkHref={"#line" + uid} y={42} />
    <rect x={80} y={47} width={184} height={6} rx={3} />
    <rect x={80} y={57} width={184} height={6} rx={3} />
    <rect x={80} y={67} width={54} height={6} rx={3} />
    <rect x={384} y={58} width={56} height={6} rx={3} />

    <use xlinkHref={"#line" + uid} y={84} />
    <rect x={80} y={105} width={69} height={6} rx={3} />
    <rect x={80} y={95} width={184} height={6} rx={3} />
    <rect x={384} y={100} width={56} height={6} rx={3} />
  </svg>
);
